//In side by side view we are considering:-
//LeftSideView ==> Source statement
//Right SideView ==> Target statement
import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Page from 'components/util/page-component';
import LeftSideView from 'pages/side-by-side-compare/left-side/left-side-view';
import RightSideView from 'pages/side-by-side-compare/right-side/right-side-view';
import {
  setAnnotationsForMapping,
  sideBySideViewModeAction,
  resetSideBySideViewMode,
} from 'store/actions/side-by-side-view-annotations-actions';
import { setLeftStatementSelected } from 'store/actions/source-statement-actions';
import { setSourceStatementLoaded } from 'store/actions/load-source-statement-actions';
import {
  removeAutoTieoutWorkpaperReference,
  resetAutoTieoutStatusForBanner,
  setAutoTieoutWorkpaperReference,
  setAutoTieoutStatusForBanner,
} from 'store/actions/auto-tieout/workpaper-details-action';
import { TAB_NAME } from 'constants/util/side-by-side-utils';
import AnnotationDisplayOptions from 'models/data/annotation-display-filter-options-model';
import { setSideBySideSyncScroll } from 'store/actions/side-by-side-statement/side-by-side-statement-actions';
import { clearSideBySideElementsMap } from 'store/actions/action-creators';
import { isBothLegacyOrOCRInSideBySideView } from 'utils/sync-scroll-utils';
import {
  clearAllLeftStatementData,
  processAutoTieout,
  retryAutoTieout,
} from 'store/actions/statement-content-actions';
import {
  deRegisterLeftScrollListeners,
  deRegisterRightScrollListeners,
  registerLeftScrollListeners,
  registerRightScrollListeners,
} from 'utils/sync-scroll-utils';
import {
  AUTO_TIEOUT_COMPARE_MODE,
  SIDE_BY_SIDE_VIEW_LEGACY_COMBINATION_STATEMENT,
  SIDE_BY_SIDE_VIEW_OCR_COMBINATION_STATEMENT,
  SIDE_BY_SIDE_COMPARE_MODE,
  AUTO_TIEOUT_COMPARE_MODE_INPROGRESS,
  TRAIL_BALANCE_MODE,
} from 'constants/feature/statement-content-constants';
import {
  resetAnnotationDisplayAndPositionOption,
  setAnnotationDisplayOption,
} from 'store/actions/annotation-display-actions';
import { disableAllElementsCallout } from 'store/actions/statement-content-annotation-creation-actions';
import { setAnnotationsPosition } from 'store/actions/statement-summary/statement-annotations-update-actions';
import { ANNOTATION_POSITIONS } from 'constants/feature/annotation-elements-constants';
import { setAnnotationsFontSize } from 'store/actions/statement-summary/statement-annotations-fontsize-actions';
import { getLinkedStatementsAction } from 'store/actions/linked-statement-list-actions';
import { closeSocketClient } from 'store/actions/statement-socket-actions';
import SideBySideViewFooter from './side-by-side-view-footer';
import SideBySideViewSubHeader from './side-by-side-view-subheader';
import SideBySideViewHeader from './side-by-side-view-header';
import SideBySideViewBanner from './side-by-side-view-banner';
import { retryTrialBalance } from 'store/actions/trial-balance/trial-balance-action';
import { updatePendingAutoTieoutTBStep } from 'store/actions/trial-balance/trial-balance-action';
import { TB_PENDING_STEPS } from 'constants/feature/statement-creation-constants';

export const SIDE_BY_SIDE_BLOCK = 'side-by-side-page';
export const SIDE_BY_SIDE_BLOCK_ID = 'side-by-side-page-id';

export const SideBySideView = (props) => {
  const { statementId, revisionId } = useParams();
  const {
    setLeftStatementSelected,
    clearSideBySideElementsMap,
    setAnnotationsForMapping,
    numberOfTargetElementSelected,
    numberOfSourceElementSelected,
    clearAllLeftStatementData,
    sideBySideSyncScroll,
    blacklineViewMode,
    setSideBySideSyncScroll,
    selectedStatement,
    leftSelectedStatement,
    revision,
    leftRevision,
    syncScrollIds,
    displayOptions,
    setAnnotationDisplayOption,
    disableAllElementsCallout,
    setAnnotationsPosition,
    annotationPosition,
    resetAnnotationDisplayAndPositionOption,
    setAnnotationsFontSize,
    sideBySideViewMode,
    sideBySideViewModeAction,
    leftCache,
    projectId,
    featureInfo,
    currentUserId,
    setAutoTieoutWorkpaperReference,
    workpaperDetails,
    processAutoTieout,
    retryAutoTieout,
    retryTrialBalance,
    resetAutoTieoutStatusForBanner,
    setAutoTieoutStatusForBanner,
    stateData,
    removeAutoTieoutWorkpaperReference,
    getLinkedStatementsAction,
    workFlowStatus,
    tbWorkFlowStatus,
    closeSocketClient,
    projectUsersList,
    isSnapshotViewLoaded,
    thresholdScaling,
    taggedElements,
    pendingAutoTieoutTBStep,
    updatePendingAutoTieoutTBStep,
    isSnapshotReadOnly,
    summaryElements,
    isSourceStatementLoaded,
    setSourceStatementLoaded,
    socketHasBeenDisconnected,
    resetSideBySideViewMode,
    highlightMappedElements,
    mappedElements,
    editPermissionAutotieout,
  } = props;
  const [selectedTab, setSelectedTab] = useState(TAB_NAME.LEFT);
  const [isSwapped, setIsSwapped] = useState(false);
  const onSwapStatements = () => setIsSwapped((oldState) => !oldState);
  const [leftStatementNavPanel, setLeftStatementNavPanel] = useState(false);
  const [rightStatementNavPanel, setRightStatementNavPanel] = useState(false);
  const [shouldDisableSyncScroll, setShouldDisableSyncScroll] = useState(false);
  const [showAutoTieoutInfoBanner, setShowAutoTieoutInfoBanner] =
    useState(false);
  const [scalingOption, setScalingOption] = useState({});
  const [thresholdOption, setThresholdOption] = useState(null);

  const geo = projectId?.split('-')[1];
  // auto tieout compare mode feature flag check
  const isAutoTieoutCompareModeEnabled =
    featureInfo?.isLoaded && !featureInfo?.isLegacyAutoTieoutEnabled(geo);

  // auto tieout to trial balance feature flag check
  const isAutoTieoutToTrialBalanceEnabled =
    featureInfo?.isLoaded && featureInfo?.getTrialBalanceEnabled(geo);

  //confirm statement from left side view
  const onConfirmStatement = () => {
    setSourceStatementLoaded(!isSourceStatementLoaded);
    setLeftStatementSelected(!isSourceStatementLoaded);
    onClearSelection();
    clearAllLeftStatementData();
    if (sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE) {
      resetAutoTieoutStatusForBanner();
      removeAutoTieoutWorkpaperReference();
      getLinkedStatementsAction(
        parseInt(projectId),
        selectedStatement.statementId,
        revision.id,
        true,
      );
      setShowAutoTieoutInfoBanner(false);
    }
  };

  useEffect(() => {
    setScalingOption(thresholdScaling?.scaling);
    setThresholdOption(String(thresholdScaling?.threshold));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thresholdScaling]);

  useEffect(() => {
    resetSideBySideViewMode();
    clearAllLeftStatementData();
    clearSideBySideElementsMap();
    setSourceStatementLoaded(false);
    setLeftStatementSelected(false);
  }, []);

  // Set default compare mode when no features are enabled
  useEffect(() => {
    if (
      featureInfo?.isLoaded &&
      !isAutoTieoutCompareModeEnabled &&
      !isAutoTieoutToTrialBalanceEnabled &&
      sideBySideViewMode?.viewMode === ''
    ) {
      sideBySideViewModeAction(SIDE_BY_SIDE_COMPARE_MODE);
    }
  }, [
    isAutoTieoutCompareModeEnabled,
    isAutoTieoutToTrialBalanceEnabled,
    sideBySideViewMode?.viewMode,
    featureInfo?.isLoaded,
  ]);

  useEffect(() => {
    const currentWorkflowStatus =
      sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE
        ? tbWorkFlowStatus
        : workFlowStatus;
    const shouldShowBanner =
      currentWorkflowStatus?.isWorkflowInProgress ||
      currentWorkflowStatus?.isCompleted ||
      currentWorkflowStatus?.isWorkflowFailed;
    setShowAutoTieoutInfoBanner(shouldShowBanner);
  }, [
    workFlowStatus?.isLoaded,
    workFlowStatus?.workflowStatus,
    tbWorkFlowStatus?.isLoaded,
    tbWorkFlowStatus?.status,
    sideBySideViewMode?.viewMode,
  ]);

  // based on the sideBySideViewMode selected updating the selected tab value
  useEffect(() => {
    if (sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE) {
      setSelectedTab(TAB_NAME.RIGHT);
    } else {
      setSelectedTab(TAB_NAME.LEFT);
    }
  }, [sideBySideViewMode.viewMode]);

  //initiate auto tieout process
  const initiateAutoTieout = async (thresholdScalingValues) => {
    setShowAutoTieoutInfoBanner(true);
    await processAutoTieout(statementId, revisionId, thresholdScalingValues);
  };

  //retry auto tieout process
  const handleRetryAutoTieout = () => {
    setShowAutoTieoutInfoBanner(true);
    setAutoTieoutStatusForBanner({
      status: AUTO_TIEOUT_COMPARE_MODE_INPROGRESS,
    });
    if (sideBySideViewMode.viewMode === TRAIL_BALANCE_MODE) {
      retryTrialBalance();
    } else {
      retryAutoTieout();
    }
  };

  useEffect(() => {
    const isAutoTieoutViewMode =
      sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE;

    if (
      isAutoTieoutViewMode &&
      leftSelectedStatement &&
      leftSelectedStatement.isLoaded
    ) {
      setSideBySideSyncScroll(false);
    } else {
      setSideBySideSyncScroll(true);
    }
  }, [sideBySideViewMode.viewMode, leftSelectedStatement]);

  //loaded statement type handling for sync scroll
  useEffect(() => {
    const viewType = isBothLegacyOrOCRInSideBySideView(
      selectedStatement,
      leftSelectedStatement,
    );
    const isBothNotLegacyOrOCRStatements = !(
      viewType === SIDE_BY_SIDE_VIEW_LEGACY_COMBINATION_STATEMENT ||
      viewType === SIDE_BY_SIDE_VIEW_OCR_COMBINATION_STATEMENT
    );

    if (leftSelectedStatement && leftSelectedStatement.isLoaded) {
      if (isBothNotLegacyOrOCRStatements) {
        if (
          (leftStatementNavPanel || rightStatementNavPanel) &&
          sideBySideSyncScroll
        ) {
          setSideBySideSyncScroll(false);
          setShouldDisableSyncScroll(true);
        } else if (
          !leftStatementNavPanel &&
          !rightStatementNavPanel &&
          !sideBySideSyncScroll
        ) {
          setSideBySideSyncScroll(true);
          setShouldDisableSyncScroll(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftStatementNavPanel, rightStatementNavPanel, leftSelectedStatement]);

  //registering and deregistering scroll listeners based on sync scroll toggle
  useEffect(() => {
    const leftStatementView =
      syncScrollIds.sourceId && document.getElementById(syncScrollIds.sourceId);
    const rightStatementView =
      syncScrollIds.targetId && document.getElementById(syncScrollIds.targetId);
    if (
      sideBySideSyncScroll &&
      leftRevision.isLoaded &&
      leftSelectedStatement.isLoaded &&
      syncScrollIds.sourceId
    ) {
      registerLeftScrollListeners(
        leftStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
      registerRightScrollListeners(
        rightStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
    } else {
      deRegisterLeftScrollListeners(
        leftStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
      deRegisterRightScrollListeners(
        rightStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
    }
    return () => {
      deRegisterLeftScrollListeners(
        leftStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
      deRegisterRightScrollListeners(
        rightStatementView,
        syncScrollIds,
        blacklineViewMode,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sideBySideSyncScroll,
    leftRevision.isLoaded,
    leftSelectedStatement.isLoaded,
    syncScrollIds.sourceId,
  ]);

  // reset scroll position to top when sync scroll is enabled
  useEffect(() => {
    if (sideBySideSyncScroll) {
      const leftStatementView = document.getElementById(syncScrollIds.sourceId);
      const rightStatementView = document.getElementById(
        syncScrollIds.targetId,
      );
      if (leftStatementView && rightStatementView) {
        leftStatementView.scrollTop = rightStatementView.scrollTop = 0;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBySideSyncScroll]);

  useEffect(() => {
    if (
      sideBySideViewMode.viewMode === TRAIL_BALANCE_MODE ||
      sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE
    ) {
      // Create fresh options without preserving workpapersSelected
      let updatedOptions = new AnnotationDisplayOptions();
      updatedOptions.showAll = true;
      updatedOptions.expandAllElements = displayOptions.expandAllElements;
      updatedOptions.workpaper = displayOptions.workpaper;
      // setdisplayOptions(updatedOptions);
      setAnnotationDisplayOption(updatedOptions);
      disableAllElementsCallout({ showCallout: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBySideViewMode.viewMode]);

  // Reset on component mount
  useEffect(() => {
    resetAnnotationDisplayAndPositionOption();
    disableAllElementsCallout({ showCallout: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Reset when statement loads (this is working!)
  useEffect(() => {
    resetAnnotationDisplayAndPositionOption();
    setAnnotationsPosition({
      position: ANNOTATION_POSITIONS[2],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revision.isLoaded, selectedStatement.isLoaded]);

  // CLEANUP - Reset on unmount
  useEffect(() => {
    return () => {
      resetAnnotationDisplayAndPositionOption();
      disableAllElementsCallout({ showCallout: false });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sideBySideViewMode.viewMode === TRAIL_BALANCE_MODE) {
      setAnnotationsPosition({ position: ANNOTATION_POSITIONS[0] });
    } else {
      setAnnotationsPosition({
        position: ANNOTATION_POSITIONS[2],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBySideViewMode.viewMode]);

  //initiate auto tieout only on updated trial balance snapshot.
  useEffect(() => {
    const handleAutoTieout = async () => {
      try {
        if (
          pendingAutoTieoutTBStep === TB_PENDING_STEPS.INITIATE_TB_AUTO_TIEOUT
        ) {
          const thresholdScalingValues = {
            threshold: Number(thresholdOption),
            scaling: scalingOption,
          };
          updatePendingAutoTieoutTBStep(TB_PENDING_STEPS.NONE);
          await initiateAutoTieout(thresholdScalingValues, true);
        }
      } catch (err) {
        console.error(
          'Failed to initiate auto tieout on updated TB data:',
          err,
        );
      }
    };

    handleAutoTieout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingAutoTieoutTBStep]);

  useEffect(() => {
    return () => {
      try {
        closeSocketClient({
          revisionId: revision.id,
          projectUserIds: projectUsersList.data.userIdToUserNameMap,
          projectId: projectId,
        });
      } catch (err) {
        console.error('Error while closing socket client:', err);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //clear side by side selected elements and reset sync scroll on confirm statement
  const onClearSelection = () => {
    clearSideBySideElementsMap();
    setSideBySideSyncScroll(true);
    shouldDisableSyncScroll && setShouldDisableSyncScroll(false);
  };

  //Memoize RightSideView to prevent re-renders when loading left statement view
  const memoizedRightSideView = useMemo(() => {
    return (
      <RightSideView
        isSourceStatementLoaded={isSourceStatementLoaded}
        isSwapped={isSwapped}
        setRightStatementNavPanel={setRightStatementNavPanel}
        rightStatementNavPanel={rightStatementNavPanel}
        sideBySideViewMode={sideBySideViewMode}
      />
    );
  }, [
    isSwapped,
    isSourceStatementLoaded,
    rightStatementNavPanel,
    sideBySideViewMode.viewMode,
  ]);

  return (
    <Page className={SIDE_BY_SIDE_BLOCK}>
      <SideBySideViewHeader
        BLOCK={SIDE_BY_SIDE_BLOCK}
        selectedTab={selectedTab}
        setAnnotationsForMapping={setAnnotationsForMapping}
        sideBySideSyncScroll={sideBySideSyncScroll}
        setSideBySideSyncScroll={setSideBySideSyncScroll}
        shouldDisableSyncScroll={shouldDisableSyncScroll}
        displayOptions={displayOptions}
        setAnnotationDisplayOption={setAnnotationDisplayOption}
        disableAllElementsCallout={disableAllElementsCallout}
        setAnnotationsPosition={setAnnotationsPosition}
        annotationPosition={annotationPosition}
        setAnnotationsFontSize={setAnnotationsFontSize}
        initiateAutoTieout={initiateAutoTieout}
        sideBySideViewMode={sideBySideViewMode}
        leftCache={leftCache}
        currentUserId={currentUserId}
        clearAllLeftStatementData={clearAllLeftStatementData}
        setAutoTieoutWorkpaperReference={setAutoTieoutWorkpaperReference}
        workpaperDetails={workpaperDetails}
        resetAutoTieoutStatusForBanner={resetAutoTieoutStatusForBanner}
        stateData={stateData}
        removeAutoTieoutWorkpaperReference={removeAutoTieoutWorkpaperReference}
        setShowAutoTieoutInfoBanner={setShowAutoTieoutInfoBanner}
        isSnapshotViewLoaded={isSnapshotViewLoaded}
        thresholdScaling={thresholdScaling}
        selectedStatement={selectedStatement}
        taggedElements={taggedElements}
        syncScrollIds={syncScrollIds}
        isSnapshotReadOnly={isSnapshotReadOnly}
        summaryElements={summaryElements}
        workFlowStatus={
          sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE
            ? tbWorkFlowStatus
            : workFlowStatus
        }
        socketHasBeenDisconnected={socketHasBeenDisconnected}
        highlightMappedElements={highlightMappedElements}
        mappedElements={mappedElements}
        scalingOption={scalingOption}
        setScalingOption={setScalingOption}
        thresholdOption={thresholdOption}
        setThresholdOption={setThresholdOption}
        editPermissionAutotieout={editPermissionAutotieout}
      />
      <SideBySideViewBanner
        BLOCK={SIDE_BY_SIDE_BLOCK}
        projectId={projectId}
        stateData={stateData}
        showAutoTieoutInfoBanner={showAutoTieoutInfoBanner}
        leftRevision={leftRevision}
        leftSelectedStatement={leftSelectedStatement}
        selectedStatement={selectedStatement}
        sideBySideViewMode={sideBySideViewMode}
        workFlowStatus={
          sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE
            ? tbWorkFlowStatus
            : workFlowStatus
        }
        handleRetryAutoTieout={handleRetryAutoTieout}
        setShowAutoTieoutInfoBanner={setShowAutoTieoutInfoBanner}
        isSnapshotReadOnly={isSnapshotReadOnly}
      />
      <SideBySideViewSubHeader
        BLOCK={SIDE_BY_SIDE_BLOCK}
        onClick={onSwapStatements}
      />
      <div
        className={classnames(`${SIDE_BY_SIDE_BLOCK}__body-section`, {
          [`${SIDE_BY_SIDE_BLOCK}__body-section__swap`]: isSwapped,
        })}
      >
        <LeftSideView
          isSourceStatementLoaded={isSourceStatementLoaded}
          setSourceStatementLoaded={setSourceStatementLoaded}
          isSwapped={isSwapped}
          onConfirmStatement={onConfirmStatement}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          setLeftStatementNavPanel={setLeftStatementNavPanel}
          leftStatementNavPanel={leftStatementNavPanel}
          sideBySideViewMode={sideBySideViewMode}
          isAutoTieoutCompareModeEnabled={isAutoTieoutCompareModeEnabled}
          isAutoTieoutToTrialBalanceEnabled={isAutoTieoutToTrialBalanceEnabled}
          sideBySideViewModeAction={sideBySideViewModeAction}
          featureInfo={featureInfo}
          projectId={projectId}
          statementId={statementId}
          revisionId={revisionId}
          selectedStatement={selectedStatement}
        />
        {memoizedRightSideView}
      </div>
      {isSourceStatementLoaded &&
        sideBySideViewMode?.viewMode === SIDE_BY_SIDE_COMPARE_MODE && (
          <SideBySideViewFooter
            BLOCK={SIDE_BY_SIDE_BLOCK}
            isSwapped={isSwapped}
            onClearSelection={onClearSelection}
            numberOfTargetElementSelected={numberOfTargetElementSelected}
            numberOfSourceElementSelected={numberOfSourceElementSelected}
          />
        )}
    </Page>
  );
};

const mapStateToProps = (state) => {
  const {
    data,
    ui: {
      sideBySideView: {
        sideBySideElementMap,
        sideBySideViewMode,
        shouldHighlightMappedElements: { highlightMappedElements },
        autoTieout: {
          workpaperDetails,
          workFlowStatus,
          mappedElements: autoTieoutMappedElements,
        },
        trialBalance: {
          isSnapshotViewLoaded,
          thresholdScaling,
          taggedElements,
          pendingAutoTieoutTBStep,
          tbWorkFlowStatus,
          isSnapshotReadOnly,
          mappedElements: trialBalanceMappedElements,
        },
      },
      statementPage: {
        syncScrollIds,
        modes: { sideBySideSyncScroll, blacklineViewMode },
      },
      isSourceStatementLoaded,
    },
    sockets: {
      statementSocket: { socketHasBeenDisconnected },
    },
  } = state;

  const {
    selectedStatement,
    projectUsersList,
    leftSelectedStatement,
    selectedProject: { id },
    revision,
    leftRevision,
    featureInfo,
    annotationDisplayOptions,
    statementSummary: { annotationPosition, elements },
    leftStatementContent: {
      leftSectionsCache: { leftCache },
    },
    currentUser: { id: currentUserId },
    editPermission: { editPermissionAutotieout },
  } = data;

  return {
    numberOfSourceElementSelected:
      sideBySideElementMap && sideBySideElementMap.sizeOfSourceMapping,
    numberOfTargetElementSelected:
      sideBySideElementMap && sideBySideElementMap.sizeOfTargetMapping,
    sideBySideSyncScroll,
    blacklineViewMode,
    selectedStatement,
    leftSelectedStatement,
    revision,
    displayOptions: annotationDisplayOptions,
    leftRevision,
    syncScrollIds,
    annotationPosition,
    summaryElements: elements,
    sideBySideViewMode,
    leftCache,
    featureInfo,
    projectId: id,
    currentUserId,
    workpaperDetails,
    stateData: data,
    workFlowStatus,
    tbWorkFlowStatus,
    projectUsersList,
    isSnapshotViewLoaded,
    thresholdScaling,
    taggedElements,
    pendingAutoTieoutTBStep,
    isSnapshotReadOnly,
    isSourceStatementLoaded,
    socketHasBeenDisconnected,
    highlightMappedElements,
    mappedElements:
      sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE
        ? autoTieoutMappedElements
        : sideBySideViewMode.viewMode === TRAIL_BALANCE_MODE
          ? trialBalanceMappedElements
          : null,
    editPermissionAutotieout,
  };
};

const mapDispatchToProps = {
  setLeftStatementSelected,
  clearSideBySideElementsMap,
  setAnnotationsForMapping,
  clearAllLeftStatementData,
  setSideBySideSyncScroll,
  setAnnotationDisplayOption,
  disableAllElementsCallout,
  setAnnotationsPosition,
  resetAnnotationDisplayAndPositionOption,
  setAnnotationsFontSize,
  processAutoTieout,
  retryAutoTieout,
  retryTrialBalance,
  sideBySideViewModeAction,
  setAutoTieoutWorkpaperReference,
  resetAutoTieoutStatusForBanner,
  setAutoTieoutStatusForBanner,
  removeAutoTieoutWorkpaperReference,
  getLinkedStatementsAction,
  closeSocketClient,
  updatePendingAutoTieoutTBStep,
  setSourceStatementLoaded,
  resetSideBySideViewMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBySideView);
